module.exports = __webpack_public_path__ + "static/media/8 Pistol Grip.e1041fda.jpg";